module.exports = __webpack_public_path__ + "img/feature_buy_th.f33a2db9.png";